export default __webpack_public_path__ + "static/media/5-3.391544e7.mp3";